<template>
  <div class="vx-card">
    <grid-panel
        :column-defs="columnDefs"
        height="md-plus"
        :url="() => this.$api.facilities.sections.list(id)"
        :auto-size="true"
        @rowClicked="view"
        title="Sections"
    >
      <vs-dropdown-item v-if="componentAccess.canCreate.access">
        <span
            class="flex items-center"
            @click="$router.push({ name: 'facilities.sections.create' })"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
          <span>Create Section</span>
        </span>
      </vs-dropdown-item>

    </grid-panel>
  </div>
</template>

<script>
import GridPanel from '@/views/components/ag-grid/GridPanel';
import CellRendererDate from "../../../components/ag-grid/cell-renderer/CellRendererDate";
import CanAccessMixin from "@/components/mixins/CanAccessMixin";
import {dateFilterParams} from '../../../components/ag-grid/filter-params/DateComparator';

export default {
  name: 'SectionList',
  components: {
    GridPanel,
    CellRendererDate,
  },
  mixins: [CanAccessMixin],
  data() {
    return {
      componentAccess: {
        canCreate: {
          route: 'facilities.sections.create',
          access: false,
        },
      },
      columnDefs: [
        {
          headerName: 'Section #',
          field: 'id',
          width: 350,
        },
        {
          headerName: 'Section',
          field: 'Section',
          width: 350,
        },
        {
          headerName: 'Inception Date',
          field: 'InceptionDate',
          width: 350,
          cellRenderer: "CellRendererDate",
          filterParams: dateFilterParams,
        },
        {
          headerName: 'Expiry Date',
          field: 'ExpiryDate',
          width: 350,
          cellRenderer: "CellRendererDate",
          filterParams: dateFilterParams,
        },
      ]
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    async view({data}) {
      const route = 'facilities.sections.view';

      if (await this.canAccessRoute(route)) {
        this.$router.push({name: route, params: {id: this.id, sectionId: data.id}}).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>

</style>
